/**
 * PDP 短视频
 * - PC：始终按 4 列槽位（不足 4 个也占 1/4 宽），gap=8
 * - ≤4：静态列表，无左右箭头
 * - >4：Swiper，一次切一张，显示箭头
 * - 点击打开预览弹窗（PC/移动共用），max-height 80dvh，X 关，左右切
 */
(function () {
  var GAP = 8;
  var PC_PER_VIEW = 4;

  function parseSlides(root) {
    return Array.from(root.querySelectorAll('[data-short-video-slide]'));
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 769px)').matches;
  }

  function buildModalMedia(slide) {
    var type = slide.dataset.sourceType || 'mp4';
    var ytId = slide.dataset.youtubeId || '';
    var mp4 = slide.dataset.mp4Src || '';
    var poster = slide.dataset.poster || '';

    var wrap = document.createElement('div');
    wrap.className = 'oc-mr-short-videos-modal__media-wrap';

    if (type === 'youtube' && ytId) {
      // YouTube 均为 16:9：不裁切放大，iframe 完整 contain 进 16:9 框
      wrap.classList.add('oc-mr-short-videos-modal__media-wrap--youtube');
      var iframe = document.createElement('iframe');
      iframe.className = 'oc-mr-short-videos-modal__media oc-mr-short-videos-modal__media--youtube';
      iframe.src =
        'https://www.youtube.com/embed/' +
        ytId +
        '?autoplay=1&mute=0&controls=1&playsinline=1&rel=0&enablejsapi=1';
      iframe.allow = 'autoplay; encrypted-media; fullscreen';
      iframe.allowFullscreen = true;
      iframe.title = 'Video preview';
      wrap.appendChild(iframe);
      return wrap;
    }

    wrap.classList.add('oc-mr-short-videos-modal__media-wrap--video');
    var video = document.createElement('video');
    video.className = 'oc-mr-short-videos-modal__media oc-mr-short-videos-modal__media--video';
    video.src = mp4;
    if (poster) video.poster = poster;
    video.controls = true;
    video.playsInline = true;
    video.autoplay = true;
    wrap.appendChild(video);
    return wrap;
  }

  function playStripVideos(root) {
    root.querySelectorAll('.oc-mr-short-videos__video').forEach(function (video) {
      video.muted = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    });
  }

  function initGallery(root) {
    if (root.dataset.ocShortInit === 'true') return;
    root.dataset.ocShortInit = 'true';

    var slides = parseSlides(root);
    if (!slides.length) {
      root.hidden = true;
      return;
    }

    var swiperEl = root.querySelector('.oc-mr-short-videos__swiper');
    var prevBtn = root.querySelector('[data-short-video-prev]');
    var nextBtn = root.querySelector('[data-short-video-next]');
    var modal = root.querySelector('[data-short-video-modal]');
    var modalFrame = root.querySelector('[data-short-video-modal-frame]');
    var modalClose = root.querySelector('[data-short-video-modal-close]');
    var modalPrev = root.querySelector('[data-short-video-modal-prev]');
    var modalNext = root.querySelector('[data-short-video-modal-next]');

    var activeIndex = 0;
    var swiper = null;
    var needCarousel = slides.length > PC_PER_VIEW;

    function syncListMode() {
      var desktop = isDesktop();
      var useSwiper = desktop ? needCarousel : slides.length > 2;

      root.classList.toggle('is-static', !useSwiper);
      root.classList.toggle('is-carousel', useSwiper);

      if (prevBtn) prevBtn.hidden = !useSwiper;
      if (nextBtn) nextBtn.hidden = !useSwiper;

      if (useSwiper && typeof Swiper !== 'undefined' && swiperEl) {
        if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
        swiper = new Swiper(swiperEl, {
          slidesPerView: desktop ? PC_PER_VIEW : Math.min(2.2, slides.length),
          slidesPerGroup: 1,
          spaceBetween: GAP,
          watchOverflow: true,
          speed: 300,
          navigation: {
            prevEl: prevBtn,
            nextEl: nextBtn,
          },
          breakpoints: {
            0: {
              slidesPerView: Math.min(2.2, slides.length),
              spaceBetween: GAP,
            },
            769: {
              // 始终按 4 列计算宽度，即使 slide 不足 4
              slidesPerView: PC_PER_VIEW,
              spaceBetween: GAP,
            },
          },
        });
      } else if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
    }

    syncListMode();
    playStripVideos(root);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncListMode, 150);
    });

    function clearModal() {
      if (!modalFrame) return;
      modalFrame.innerHTML = '';
    }

    function updateModalNav() {
      var multi = slides.length > 1;
      if (modalPrev) modalPrev.hidden = !multi;
      if (modalNext) modalNext.hidden = !multi;
    }

    function applyLandscapeClass(videoEl) {
      if (!modal || !videoEl) return;
      var w = videoEl.videoWidth || 0;
      var h = videoEl.videoHeight || 0;
      // 横版 MP4 改用 16:9 框，避免塞进竖框后圆角黑边突出
      modal.classList.toggle('is-landscape', w > 0 && h > 0 && w / h > 1);
    }

    function openModal(index) {
      if (!modal || !modalFrame || !slides.length) return;
      activeIndex = ((index % slides.length) + slides.length) % slides.length;
      var slide = slides[activeIndex];
      var isYoutube = (slide.dataset.sourceType || '') === 'youtube' && !!slide.dataset.youtubeId;

      // YouTube → 16:9；竖版 MP4 → 9:16；横版 MP4 在 metadata 后切 16:9
      modal.classList.toggle('is-youtube', isYoutube);
      modal.classList.toggle('is-mp4', !isYoutube);
      modal.classList.remove('is-landscape');

      clearModal();
      var mediaWrap = buildModalMedia(slide);
      modalFrame.appendChild(mediaWrap);
      updateModalNav();

      var videoEl = mediaWrap.querySelector('video');
      if (videoEl) {
        if (videoEl.readyState >= 1) {
          applyLandscapeClass(videoEl);
        } else {
          videoEl.addEventListener('loadedmetadata', function onMeta() {
            videoEl.removeEventListener('loadedmetadata', onMeta);
            applyLandscapeClass(videoEl);
          });
        }
      }

      // 挂到 body，保证 fixed 相对视口（X / 左右箭头）
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      if (typeof modal.showModal === 'function') {
        if (!modal.open) modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.body.classList.add('oc-mr-modal-open');
    }

    function closeModal() {
      clearModal();
      if (!modal) return;
      if (typeof modal.close === 'function') {
        if (modal.open) modal.close();
      } else {
        modal.removeAttribute('open');
      }
      document.body.classList.remove('oc-mr-modal-open');
    }

    function stepModal(delta) {
      openModal(activeIndex + delta);
    }

    root.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-short-video-open]');
      if (openBtn && root.contains(openBtn)) {
        e.preventDefault();
        var slide = openBtn.closest('[data-short-video-slide]');
        var idx = slides.indexOf(slide);
        openModal(idx >= 0 ? idx : 0);
      }
    });

    if (modalClose) {
      modalClose.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }
    if (modalPrev) {
      modalPrev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        stepModal(-1);
      });
    }
    if (modalNext) {
      modalNext.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        stepModal(1);
      });
    }

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
      modal.addEventListener('cancel', function (e) {
        e.preventDefault();
        closeModal();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!modal || !modal.open) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') stepModal(-1);
      if (e.key === 'ArrowRight') stepModal(1);
    });
  }

  function boot() {
    document.querySelectorAll('[data-oc-short-videos]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
